// @core/stores/booking/BookingReviewStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { bookingApi } from '@core/api';
import type {
  BookingReviewResponse,
  CreateReviewRequest,
  ListReviewsResponse,
  RespondToReviewRequest,
} from '@core/types/booking';

class BookingReviewStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Create review
   */
  async CreateReview(target_type: string, target_id: string, data: CreateReviewRequest): Promise<BookingReviewResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.CreateReview(target_type, target_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * List resource reviews
   */
  async ListResourceReviews(resource_id: string, params?: { cursor?: string | number | boolean; direction?: string | number | boolean; limit?: string | number | boolean; min_rating?: string | number | boolean; sort?: string | number | boolean; sort_by?: string | number | boolean; }): Promise<ListReviewsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.ListResourceReviews(resource_id, params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Respond to review
   */
  async RespondToReview(review_id: string, data: RespondToReviewRequest): Promise<BookingReviewResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.RespondToReview(review_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const bookingReviewStore = new BookingReviewStore();
